import useMyId from '../../../../../hooks/useMyId'

export const useIsAgentPoolFavoriteEnabled = () => {
  const myId = useMyId()
  const isGuestOrRoot = myId != null && myId < 0

  return !isGuestOrRoot
}
